var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._g({staticClass:"table-cell",class:[("field-" + _vm.field), {textEllipsis: _vm.textEllipsis}],attrs:{"colspan":_vm.fill ? '100%' : '1'}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }